/*
==========================================
Custom JS for Cart page
==========================================
*/


/* -- 紙袋機能 Start -- */
// キャンセルボタン押下時
const closeModal = () => {
  document.querySelector(".product-media-modal__toggle").click();
}

// ギフト決定時
const selectGiftItem = (e) => {
  e.preventDefault();
  const addedItem = document.querySelector('input[name="gift-bag-item-selector"][data-item_in_cart]:checked:not([disabled])');
  if(addedItem){
    // 選択したアイテムがカート追加済みの場合、アラート通知して処理を中断
    alert(`${addedItem.getAttribute("data-item_in_cart")}は選択済みです。数量変更はカート内で可能です。`)
  }else{
    const selectedElem = document.querySelectorAll('input[name="gift-bag-item-selector"]:checked:not([disabled])');
    if(selectedElem.length > 0){
      e.target.classList.add('is-loading');
      let formData = { items: []};
      selectedElem.forEach(selectedItem => {
        formData.items.push({
          id: Number(selectedItem.value),
          quantity: 1
        })
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'dataType': 'json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
        .then(response => response.json())
        .then(data => {
          if (data && typeof data.items === 'undefined') {
            alert("在庫を超えて購入できませんでした。ページを再表示します。");
          }
          window.location.reload();
        })
        .catch((error) => {
          alert("エラーが発生しました。ページを再表示します。");
          console.error('Error:', error);
          window.location.reload()
        });
    }else{
      alert("紙袋を選択してください。")
    }
  }
}
/* -- 紙袋機能 End -- */


/* -- 配送日時指定 Start -- */
// お届け日指定 日付リスト生成
// 1.お届け最短日 = 営業日を考慮した最短日付
// 2.お届け最長日 - お届け最短日 + 1 = 生成する日付数
// 3.生成する日付数までwhile()ループ処理を行う
//   3-1.現在日付が営業日かどうか？isDeliveryNG()メソッドにて判定
//   3-2.営業日の場合、日付をフォーマットしてセレクターオプションを生成
//   3-3.処理完了後、日付を+1してループに戻る
window.addEventListener('DOMContentLoaded',() => {
  const delivery_date = document.querySelector('#delivery-date-selector');
  const selected_delivery_date = delivery_date.value,
    max_days_later = Number(delivery_date.getAttribute("date-max_days_later")),
    ng_date_list = JSON.parse(delivery_date.getAttribute("data-ng_date_list")),
    unselectable_date_list = JSON.parse(delivery_date.getAttribute("data-unselectable_date_list"));
  let min_days_later = Number(delivery_date.getAttribute("date-min_days_later"));

  let has_nikko_discount = false

  const nikko_discount_el = document.querySelector('[data-nikko-shareholder-discount]')
  if (nikko_discount_el && nikko_discount_el.dataset.nikkoShareholderDiscount === 'true') {
    has_nikko_discount = true
  }


  if (has_nikko_discount) {
    min_days_later = 14

    const giftLinks = document.querySelectorAll('.c-add-gift-link')
    // if (giftLinks) {
    //   giftLinks.forEach(el => {
    //     el.style.display = 'none'
    //   })
    // }

    const nikkoGiftNotes = document.querySelectorAll('[data-nikko-gift-note]')

    // if (nikkoGiftNotes && nikkoGiftNotes.length) {
    //   nikkoGiftNotes.forEach(el => {
    //     el.style.display = 'block'
    //   })
    // }
  }

  
  // 配送NG判定メソッド
  //  配送NG日でなければtrueを返し、それ以外はfalseを返す
  const isDeliveryNG = (_date) => {
    const year = _date.getFullYear();
    const month = _date.getMonth() + 1;
    const day = _date.getDate();
    const dayOfWeek = _date.getDay();
    const delivery_date_txt = year + "/" + ('00' + month).slice(-2) + "/" + ('00' + day).slice(-2);
    if ( unselectable_date_list && unselectable_date_list.includes(delivery_date_txt) ){
      return true;
    } else {
      return false;
    }
  }

  // 営業日判定メソッド
  //  土日祝日・及び配送NG日でなければtrueを返し、それ以外はfalseを返す
  const isHoliday = (_date) => {
    const year = _date.getFullYear();
    const month = _date.getMonth() + 1;
    const day = _date.getDate();
    const dayOfWeek = _date.getDay();
    const holidays = holiday_jp.between(_date, _date);
    const delivery_date_txt = year + "/" + ('00' + month).slice(-2) + "/" + ('00' + day).slice(-2);
    if (dayOfWeek === 0 || 
      dayOfWeek === 6 || 
      holidays.find(days => days.date.getFullYear() === year && days.date.getMonth() + 1 === month && days.date.getDate() === day) ||
      ( ng_date_list && ng_date_list.includes(delivery_date_txt) )
    ) {
      return true;
    } else {
      return false;
    }
  }
  
  let date_obj = new Date(),
    min_date_obj = new Date(),
    max_date_obj = new Date(),
    business_days_count = 0;
  
  // 選択肢として表示する日数を算出
  const dispDays = max_days_later - min_days_later;

  // ギフトラッピングが追加されている場合、最小日付を+1
  let wrappingFlg = false;
  if(document.querySelector('.cart-item__gift-items')){
    min_days_later++;
    wrappingFlg = true;
  }


  // 最小日付の算出
  let counter_for_min_day = 0,
    index_for_min_day = 0;
  while(counter_for_min_day < 365){
    // 最小日付が営業日の場合、営業日から開始するように最短日数を調整
    if (!isHoliday(min_date_obj)) {
      if (counter_for_min_day === min_days_later){
        min_days_later = index_for_min_day;
        break;
      } else if(!isHoliday(min_date_obj)){
        counter_for_min_day++;
      }
    }
    min_date_obj.setDate(min_date_obj.getDate() + 1);
    index_for_min_day++;
  }

  
  // 営業日判定ループ
  let index_for_disp_days = 0;
  business_days_count += min_days_later;
  date_obj.setDate(date_obj.getDate() + min_days_later);
  while (index_for_disp_days <= dispDays) {
    // 配送NGでない日付の場合、セレクターを生成
    if (!isDeliveryNG(date_obj)) {
      let date_year = date_obj.getFullYear(),
        date_month = ('00' + (date_obj.getMonth()+1)).slice(-2),
        date_day = ('00' + date_obj.getDate()).slice(-2);
      let delivery_date_txt = date_year + "/" + date_month + "/" + date_day;

      let delivery_date_elem = `<option value="${delivery_date_txt}"${delivery_date_txt === selected_delivery_date ? "selected" : ""}>${delivery_date_txt}</option>`;
      delivery_date.insertAdjacentHTML('beforeend', delivery_date_elem);
      business_days_count++;
    }
    date_obj.setDate(date_obj.getDate() + 1);
    index_for_disp_days++;
  }

  delivery_date.removeAttribute('disabled');

  // 配送日付が表示前の最小選択日付の場合、最新の最小日付を選択してUpdate
  const initialValue = delivery_date.getAttribute('value');
  if(delivery_date.querySelectorAll(`option[value="${initialValue}"]`).length === 0){
    delivery_date.selectedIndex = 0;
    delivery_date.dispatchEvent(new CustomEvent("change"));
  }
})

// CartAttributes[お届け日指定]更新
const updateAttribute_DeliveryDate = (e) => {
  const form_data = {
    attributes: {
      'delivery_date': e.target.value
    }
  }
  fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'dataType': 'json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(form_data)
    })
    .then((data) => {
      console.log(`delivery_date updated. ${e.target.value}`)
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}

// CartAttributes[お届け時間指定]更新
const updateAttribute_DeliveryTime = (e) => {
  const form_data = {
    attributes: {
      'delivery_time': e.target.value
    }
  }
  fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'dataType': 'json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(form_data)
    })
    .then((data) => {
      console.log(`delivery_time updated. ${e.target.value}`)
    })
    .catch((error) => {
      console.error('Error:', error);
    });
}
/* -- 配送日時指定 End -- */


/*
  「複数配送」ボタンの制御
*/
document.addEventListener('giftship.loaded', function(){
  const multishipBtn = document.getElementById('gs__toggle-box')
  const multishipBtnContainer = document.querySelector('.c-cart__multiship-btn')

  if (multishipBtn && multishipBtnContainer) {
    multishipBtnContainer.appendChild(multishipBtn)

    const multishipLabel = multishipBtn.querySelector('label')
    multishipLabel.addEventListener('click', function(){
      document.querySelector('.c-cart__multiship-loader').classList.add('is-active')
      setTimeout(function(){
        // ブラウザバック対策
        document.querySelector('.c-cart__multiship-loader').classList.remove('is-active')
      }, 5000)
    })
  }

})


// if (getCurrentNikkoDiscount()) {

//   if (window.Shopify.isLoggedOutOnCart) {
//     location.href = '/discount/000000000000'
//   }

//   document.querySelector('.c-cart__shareholder-shipping-note').style.display = 'block'

//   // 送料無料表示の更新
//   document.querySelector('[data-cart-upsell-text]').textContent = 'こちらの商品もおすすめです'

//   // ポイントセクションの非表示
//   const style = document.createElement('style')
//   style.textContent = '.easy-points__subtotal-points, .ep-login-prompt--text, .easy-points-form__container, .c-point-note, .mrpoint--cart {display: none;}'
//   document.body.appendChild(style)
// }

if (hasNikkoShareholderDiscount()) {
  // 送料無料表示の更新
  document.querySelector('[data-cart-upsell-text]').textContent = 'こちらの商品もおすすめです'
}

// ニッコーの株主クーポンチェック
function hasNikkoShareholderDiscount() {

  let has_nikko_discount = false

  const nikko_discount_el = document.querySelector('[data-nikko-shareholder-discount]')
  if (nikko_discount_el && nikko_discount_el.dataset.nikkoShareholderDiscount === 'true') {
    has_nikko_discount = true
  }

  return has_nikko_discount
}

// ニッコーの株主クーポンチェック
function getCurrentNikkoDiscount() {
  let nikkoDiscount = null
  const regexp = new RegExp(/^NK[N|M]/)
  const cookies = document.cookie.split(';')
  const foundCookie = cookies.find(
    (cookie) => cookie.split('=')[0].trim() === 'discount_code'.trim()
  )
  if (foundCookie) {
    const cookieValue = decodeURIComponent(foundCookie.split('=')[1])


    if (regexp.test(cookieValue)) {
      nikkoDiscount = cookieValue
    }
    const appliedShareholder = document.querySelector(`[data-shareholder-coupon="${nikkoDiscount}"]`)

    if (appliedShareholder) {

      const appliedStatus = appliedShareholder.querySelector('[data-discount-status]')
      const applyLink = appliedShareholder.querySelector('[data-discount-link]')

      appliedShareholder.classList.add('is-selected')
      appliedShareholder.dataset.status = 'selected'
      appliedStatus.classList.add('is-selected')
      appliedStatus.textContent = '選択中'
      applyLink.classList.add('is-selected')
      applyLink.innerHTML = '<span>選択中</span>'


    }
  }

  if (window.appliedDiscountTitles.length > 0) {
    window.appliedDiscountTitles.forEach(d => {
      if (regexp.test(d)) {
        nikkoDiscount = d
      }
    })
  }

  return nikkoDiscount
}


// 送料無料クーポンを付与したパーマリンクの生成＆遷移
function checkoutWithShareholderShipping(code, ids, qtys, props) {
  let items = []
  const idArray = ids.split(',')
  const qtyArray = qtys.split(',')
  idArray.forEach((id, index) => {
    const qtyEl = document.querySelector(`[data-id-for-qty="${id}"]`)
    const qty = qtyEl ? qtyEl.value : qtyArray[index]
    const itemData = `${id}:${qty}`
    items.push(itemData)
  })

  let discounts = `?discount=${code}`

  if (getCurrentNikkoDiscount()) {
    discounts += `,${getCurrentNikkoDiscount()}`
  }

  let permaLink = `/cart/${items.join(',')}${discounts}`

  const deliveryDateSelector = document.querySelector('[name="attributes[delivery_date]"]')
  const deliveryTimeSelector = document.querySelector('[name="attributes[delivery_time]"]')

  if (deliveryDateSelector && !deliveryDateSelector.disabled && deliveryDateSelector.value !== '') {
    permaLink += `&attributes[delivery_date]=${deliveryDateSelector.value}`
  }

  if (deliveryTimeSelector && !deliveryTimeSelector.disabled && deliveryTimeSelector.value !== '') {
    permaLink += `&attributes[delivery_time]=${deliveryTimeSelector.value}`
  }

  if (props !== '') {
    permaLink += `&note=${props}`
  }

  console.log({permaLink})

  window.location.href = permaLink
}
